import { DetailCell, RefCell } from "@/components/ExportDialog/PrintView";
import React from "react";

function InvoicePrintView({ data, colors, companyInfo }) {
  const formatCurrency = (val) => {
    console.log("totalAmount", val);
    return val.toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const docTitle =
    data?.invoiceType === "CREDIT MEMO"
      ? "CREDIT MEMO"
      : data?.invoiceType === "DEBIT MEMO"
        ? "DEBIT MEMO"
        : "INVOICE";
  return (
    <>
      {/* ===== DOCUMENT TITLE ===== */}
      <div
        className="print-section"
        style={{ textAlign: "center", marginBottom: 24 }}
      >
        <h2
          style={{
            fontSize: 26,
            fontWeight: 800,
            color: colors.primary,
            letterSpacing: "0.08em",
            textTransform: "uppercase",
            margin: 0,
          }}
        >
          {docTitle}
        </h2>
        <div
          style={{
            height: 4,
            width: 200,
            margin: "8px auto 0",
            borderRadius: 2,
            background: colors.headerBg,
          }}
        />
      </div>

      {/* ===== BILL TO + INVOICE DETAILS ===== */}
      <div
        className="print-section"
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          border: `1px solid ${colors.tableBorderColor}`,
          borderRadius: 8,
          overflow: "hidden",
          marginBottom: 20,
        }}
      >
        {/* Left: Bill To */}
        <div
          style={{
            padding: 16,
            borderRight: `1px solid ${colors.tableBorderColor}`,
          }}
        >
          <div
            style={{
              fontSize: 10,
              fontWeight: 700,
              textTransform: "uppercase",
              letterSpacing: "0.08em",
              color: colors.headerText,
              background: colors.headerBg,
              padding: "6px 12px",
              borderRadius: 4,
              marginBottom: 12,
              display: "inline-block",
            }}
          >
            Bill To
          </div>
          <p
            style={{
              fontSize: 14,
              fontWeight: 700,
              color: colors.valueColor,
              marginBottom: 4,
            }}
          >
            {data?.customer.name}
          </p>
          {data?.customer.address && (
            <p
              style={{
                fontSize: 11,
                color: colors.labelColor,
                whiteSpace: "pre-line",
                marginBottom: 4,
              }}
            >
              {data?.customer.address}
            </p>
          )}
          {data?.customer.phone && (
            <p style={{ fontSize: 11, color: colors.labelColor }}>
              Tel: {data?.customer.phone}
            </p>
          )}
          {data?.customer.email && (
            <p style={{ fontSize: 11, color: colors.labelColor }}>
              {data?.customer.email}
            </p>
          )}
          {data?.customer.taxId && (
            <p style={{ fontSize: 11, color: colors.labelColor, marginTop: 4 }}>
              Tax ID: {data?.customer.taxId}
            </p>
          )}
        </div>

        {/* Right: Invoice Details Grid */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            fontSize: 11,
          }}
        >
          <DetailCell
            label="Invoice #"
            value={data?.invoiceNo}
            colors={colors}
            highlight
          />
          <DetailCell label="Date" value={data?.invoiceDate} colors={colors} />
          <DetailCell
            label="Terms"
            value={data?.terms || "Net 30"}
            colors={colors}
          />
          <DetailCell label="Due Date" value={data?.dueDate} colors={colors} />
          <DetailCell
            label="Amount Due"
            value={`$${formatCurrency(data?.balanceDue)}`}
            colors={colors}
            highlight
          />
          <DetailCell
            label="On Board Date"
            value={data?.onBoardDate || "-"}
            colors={colors}
          />
        </div>
      </div>

      {/* ===== SHIPMENT REFERENCE ===== */}
      {(data?.bookingNo ||
        data?.originPort ||
        data?.destinationPort ||
        data?.vessel) && (
        <div
          className="print-section"
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(3, 1fr)",
            gap: 0,
            border: `1px solid ${colors.tableBorderColor}`,
            borderRadius: 8,
            overflow: "hidden",
            marginBottom: 20,
            fontSize: 11,
          }}
        >
          <RefCell
            label="File Ref / HBL"
            value={data?.bookingNo}
            colors={colors}
          />
          <RefCell label="Origin" value={data?.originPort} colors={colors} />
          <RefCell
            label="Destination"
            value={data?.destinationPort}
            colors={colors}
          />
          <RefCell
            label="Mode / Division"
            value={data?.division}
            colors={colors}
          />
          <RefCell label="Vessel" value={data?.vessel} colors={colors} />
          <RefCell
            label="Customer Ref"
            value={data?.customerRefNo}
            colors={colors}
          />
          {data?.weight != null && (
            <RefCell
              label="Weight"
              value={`${data?.weight} KG`}
              colors={colors}
            />
          )}
          {data?.measurement != null && (
            <RefCell
              label="Measurement"
              value={`${data?.measurement} CBM`}
              colors={colors}
            />
          )}
        </div>
      )}

      {/* ===== DESCRIPTION / NOTES ===== */}
      {data?.description && (
        <div
          className="print-section"
          style={{
            marginBottom: 20,
            padding: 14,
            borderRadius: 8,
            background: `${colors.sectionBg}`,
            border: `1px solid ${colors.tableBorderColor}`,
            fontSize: 11,
            color: colors.valueColor,
            whiteSpace: "pre-line",
            lineHeight: 1.6,
          }}
        >
          <span
            style={{
              fontWeight: 600,
              color: colors.primary,
              fontSize: 10,
              textTransform: "uppercase",
              letterSpacing: "0.06em",
            }}
          >
            Description
          </span>
          <p style={{ marginTop: 6 }}>{data?.description}</p>
        </div>
      )}

      {/* ===== CHARGES TABLE ===== */}
      <div
        className="print-section"
        style={{ marginBottom: 20, minHeight: 500 }}
      >
        {/* Header Row */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "2fr 2.5fr 0.8fr 0.8fr 0.7fr 1fr 1.2fr",
            background: colors.headerBg,
            color: colors.headerText,
            fontWeight: 700,
            fontSize: 10,
            textTransform: "uppercase",
            letterSpacing: "0.06em",
            borderRadius: "8px 8px 0 0",
          }}
        >
          <div style={{ padding: "10px 12px" }}>Charges</div>
          <div style={{ padding: "10px 12px" }}>Description</div>
          <div style={{ padding: "10px 12px", textAlign: "center" }}>Curr</div>
          <div style={{ padding: "10px 12px", textAlign: "center" }}>ROE</div>
          <div style={{ padding: "10px 12px", textAlign: "center" }}>Qty</div>
          <div style={{ padding: "10px 12px", textAlign: "right" }}>Rate</div>
          <div style={{ padding: "10px 12px", textAlign: "right" }}>
            Amount (USD)
          </div>
        </div>

        {/* Data Rows */}
        {data?.lines.length > 0 ? (
          data?.lines.map((line, idx) => (
            <div
              key={idx}
              style={{
                display: "grid",
                gridTemplateColumns: "2fr 2.5fr 0.8fr 0.8fr 0.7fr 1fr 1.2fr",
                fontSize: 11,
                background: idx % 2 === 0 ? "#fafafa" : "white",
                borderLeft: `1px solid ${colors.tableBorderColor}`,
                borderRight: `1px solid ${colors.tableBorderColor}`,
                borderBottom: `1px solid ${colors.tableBorderColor}30`,
              }}
            >
              <div style={{ padding: "8px 12px", fontWeight: 500 }}>
                {line?.chargeCode || "-"}
              </div>
              <div style={{ padding: "8px 12px" }}>{line.description}</div>
              <div style={{ padding: "8px 12px", textAlign: "center" }}>
                {line?.currency}
              </div>
              <div style={{ padding: "8px 12px", textAlign: "center" }}>
                {Number(line?.roe||0).toFixed(4)}
              </div>
              <div style={{ padding: "8px 12px", textAlign: "center" }}>
                {line?.quantity}
              </div>
              <div style={{ padding: "8px 12px", textAlign: "right" }}>
                {formatCurrency(line.rate)}
              </div>
              <div
                style={{
                  padding: "8px 12px",
                  textAlign: "right",
                  fontWeight: 600,
                }}
              >
                {formatCurrency(line.totalAmount)}
              </div>
            </div>
          ))
        ) : (
          <div
            style={{
              padding: "16px 12px",
              textAlign: "center",
              fontStyle: "italic",
              color: colors.labelColor,
              border: `1px solid ${colors.tableBorderColor}`,
              borderTop: "none",
            }}
          >
            No charge lines
          </div>
        )}

        {/* Total Row */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1.2fr",
            borderRadius: "0 0 8px 8px",
            overflow: "hidden",
            borderLeft: `2px solid ${colors.primary}`,
            borderRight: `2px solid ${colors.primary}`,
            borderBottom: `2px solid ${colors.primary}`,
          }}
        >
          <div
            style={{
              padding: "12px 16px",
              background: `${colors.primary}08`,
              display: "flex",
              alignItems: "center",
              gap: 16,
              fontSize: 11,
              color: colors.labelColor,
            }}
          >
            {data?.taxAmount > 0 && (
              <>
                <span>
                  Subtotal: <strong>${formatCurrency(data?.subtotal)}</strong>
                </span>
                <span>
                  Tax: <strong>${formatCurrency(data?.taxAmount)}</strong>
                </span>
              </>
            )}
            {data?.paidAmount > 0 && (
              <span>
                Paid:{" "}
                <strong style={{ color: "#16a34a" }}>
                  ${formatCurrency(data?.paidAmount)}
                </strong>
              </span>
            )}
          </div>
          <div
            style={{
              padding: "12px 16px",
              background: colors.headerBg,
              color: colors.headerText,
              textAlign: "right",
              fontWeight: 800,
              fontSize: 18,
              letterSpacing: "-0.02em",
            }}
          >
            <span
              style={{
                fontSize: 10,
                fontWeight: 500,
                display: "block",
                marginBottom: 2,
                opacity: 0.8,
              }}
            >
              {data?.paidAmount > 0 ? "BALANCE DUE" : "TOTAL AMOUNT"}
            </span>
            $
            {formatCurrency(
              data?.paidAmount > 0 ? data?.balanceDue : data?.totalAmount,
            )}
          </div>
        </div>
      </div>

      {/* ===== PAYMENT TERMS NOTICE ===== */}
      <div
        className="print-section"
        style={{
          marginBottom: 20,
          padding: 14,
          borderRadius: 8,
          border: `1px solid ${colors.tableBorderColor}`,
          background: "#fffbeb",
          fontSize: 10,
          color: "#92400e",
          lineHeight: 1.6,
        }}
      >
        <strong>IMPORTANT:</strong> All charges and duties assessed by U.S.
        Customs are for the account of the importer/consignee. Payment terms as
        stated above. Past due invoices are subject to a 1.5% monthly service
        charge. Make checks payable to {companyInfo?.name}.
      </div>

      {/* ===== REMITTANCE INFO ===== */}
      {(data?.showWireTransfer ||
        data?.showZelleDetails ||
        data?.showCreditCardDetails) && (
        <div
          className="print-section"
          style={{
            marginBottom: 20,
            padding: 16,
            borderRadius: 8,
            border: `1px solid ${colors.tableBorderColor}`,
            background: colors.sectionBg,
          }}
        >
          <p
            style={{
              fontSize: 12,
              fontWeight: 700,
              color: colors.primary,
              marginBottom: 12,
              textTransform: "uppercase",
              letterSpacing: "0.06em",
            }}
          >
            Please Remit To: {companyInfo?.name}
          </p>

          <div
            style={{
              display: "grid",
              gridTemplateColumns:
                data?.showWireTransfer && data?.showZelleDetails
                  ? "1fr 1fr"
                  : "1fr",
              gap: 16,
            }}
          >
            {data?.showWireTransfer && (
              <div
                style={{
                  padding: 12,
                  borderRadius: 6,
                  border: `1px solid ${colors.tableBorderColor}`,
                  background: "white",
                  fontSize: 11,
                }}
              >
                <p
                  style={{
                    fontWeight: 700,
                    color: colors.primary,
                    fontSize: 10,
                    textTransform: "uppercase",
                    marginBottom: 8,
                  }}
                >
                  Wire Transfer Information
                </p>
                <p style={{ color: colors.labelColor, lineHeight: 1.8 }}>
                  Bank: First National Bank
                  <br />
                  ABA Routing: 021000089
                  <br />
                  SWIFT: FNBKUS33
                  <br />
                  Account: 1234567890
                  <br />
                  Account Name: {companyInfo?.name}
                </p>
              </div>
            )}
            {data?.showZelleDetails && (
              <div
                style={{
                  padding: 12,
                  borderRadius: 6,
                  border: `1px solid ${colors.tableBorderColor}`,
                  background: "white",
                  fontSize: 11,
                }}
              >
                <p
                  style={{
                    fontWeight: 700,
                    color: colors.primary,
                    fontSize: 10,
                    textTransform: "uppercase",
                    marginBottom: 8,
                  }}
                >
                  Zelle Payment
                </p>
                <p style={{ color: colors.labelColor, lineHeight: 1.8 }}>
                  Send to: {companyInfo?.email}
                  <br />
                  Registered as: {companyInfo?.name}
                </p>
              </div>
            )}
          </div>

          {data?.showCreditCardDetails && (
            <p
              style={{ marginTop: 12, fontSize: 11, color: colors.labelColor }}
            >
              <strong>Credit Card:</strong> We accept Visa, MasterCard, and
              American Express. A 3% processing fee applies.
            </p>
          )}
        </div>
      )}

      {/* ===== NOTES ===== */}
      {data?.notes && (
        <div
          className="print-section"
          style={{
            marginBottom: 20,
            padding: 14,
            borderRadius: 8,
            borderLeft: `4px solid ${colors.primary}`,
            background: `${colors.primary}06`,
            fontSize: 11,
            color: colors.valueColor,
            whiteSpace: "pre-line",
          }}
        >
          <span
            style={{
              fontWeight: 600,
              color: colors.primary,
              fontSize: 10,
              textTransform: "uppercase",
            }}
          >
            Notes
          </span>
          <p style={{ marginTop: 4 }}>{data?.notes}</p>
        </div>
      )}
    </>
  );
}

export default InvoicePrintView;
